GammeProduitValidator.$inject = ['validator'];

export default function GammeProduitValidator(validator) {
    const instance = new validator();
    return instance;
}
